module.exports = __webpack_public_path__ + "static/media/gcp.d2115a79.svg";